import { getInboxIconByType } from 'dashboard/helper/inbox';
import { boDau } from 'dashboard/helper/boDau';

// Ten thuong hieu, khong dich. Nen tang nao khong co trong bang thi lay tu ten
// lop Channel:: — thua hon la ve mot nen tang BonBoZ khong dung.
const BRAND_NAMES = {
  // Kenh API cua Chatwoot la kenh chung, nhung o BonBoZ moi hop thu API deu di
  // qua cau noi Zalo (`zalo_bridge/`). Ve chu "Api" thi khong ai hieu do la gi.
  'Channel::Api': 'Zalo',
  'Channel::FacebookPage': 'Facebook',
  'Channel::Instagram': 'Instagram',
  'Channel::Whatsapp': 'WhatsApp',
  'Channel::Telegram': 'Telegram',
  'Channel::WebWidget': 'Website',
  'Channel::Email': 'Email',
  'Channel::Tiktok': 'TikTok',
};

export const ALL_PLATFORMS = 'all';

export const platformName = channelType =>
  BRAND_NAMES[channelType] ??
  String(channelType ?? '').replace('Channel::', '');

export const platformIcon = inbox =>
  getInboxIconByType(inbox?.channel_type, inbox?.medium);

// Dong duoi ten trang: Pancake hien ID trang. Kenh khac khong co page_id nen
// lay dinh danh gan nhat de o do khong bao gio trong.
//
// Voi Zalo doc SO DIEN THOAI truoc uid: uid la 19 chu so khong noi len dieu gi,
// nguoi truc nhin so moi biet day la tai khoan nao. Ca hai deu do cau noi dong
// len sau khi quet QR (xem ZaloController#danh_tinh) — tai khoan OA khong co so
// nen van rot ve uid, va hop thu chua quet QR thi rot ve `#14`.
//
// Instagram doc HANDLE (@bonbozclinic): ten hop thu la ten hien thi
// ("BonBoZ Clinic") nen handle khong con hien o dau khac.
//
// Doc truoc `#id` chu khong doc truoc `page_id`: kenh API khong bao gio co
// `page_id`, va mot hop thu Facebook thi khong bao gio co `zalo_uid`, nen hai
// duong nay khong dam nhau.
export const pageIdentifier = inbox =>
  inbox?.page_id ??
  inbox?.instagram_username ??
  inbox?.phone_number ??
  inbox?.website_url ??
  inbox?.additional_attributes?.zalo_phone ??
  inbox?.additional_attributes?.zalo_uid ??
  `#${inbox?.id}`;

// Chi dung tab cho nen tang THAT SU co inbox, dem tu du lieu that.
export const buildPlatformTabs = (inboxes = []) => {
  const counts = new Map();
  inboxes.forEach(inbox => {
    const key = inbox.channel_type;
    counts.set(key, (counts.get(key) ?? 0) + 1);
  });

  return [...counts.entries()].map(([key, count]) => ({
    key,
    count,
    name: platformName(key),
    icon: getInboxIconByType(key),
  }));
};

export const filterPages = (
  inboxes = [],
  platform = ALL_PLATFORMS,
  query = ''
) => {
  // Bo dau ca hai ve nhu o tab Hoi thoai: go "tuyen dung" ra "Tuyển Dụng",
  // ma go "Tuyển" van ra. Chi doi chieu ten trang va dinh danh, khong co
  // noi dung tin nen khong dinh cac tu chua "tran" nhu ben kia.
  const term = boDau(query).trim().toLowerCase();
  return inboxes.filter(inbox => {
    if (platform !== ALL_PLATFORMS && inbox.channel_type !== platform) {
      return false;
    }
    if (!term) return true;
    return boDau(`${inbox.name} ${pageIdentifier(inbox)}`)
      .toLowerCase()
      .includes(term);
  });
};

// Trang ghim len dau, ghim sau dung truoc (pinnedIds luu theo thu tu bam).
// Trang khong ghim giu nguyen thu tu cu — sort on dinh nen danh sach khong
// nhay lung tung moi lan nap lai.
export const sortPinnedFirst = (pages = [], pinnedIds = []) => {
  const thuTu = new Map(pinnedIds.map((id, i) => [Number(id), i]));
  // Chua ghim -> +Infinity, luon dung sau moi trang da ghim.
  const diem = inbox => {
    const i = thuTu.get(Number(inbox?.id));
    return i === undefined ? Infinity : pinnedIds.length - i;
  };
  return [...pages].sort((a, b) => diem(a) - diem(b));
};
